<template>
    <AppLayout :contrast="true" title="Crear destinatario">
        <Breadcrumb
            name="Directorio"
            routeName="directorio"
            page="Crear destinatario"
        />

        <form class="p-2">
            <div class="flex flex-col w-full">
                <div
                    class="bg-white rounded-lg shadow p-5 m-2 lg:mx-4 lg:max-w-3xl"
                >
                    <div class="font-medium text-gray-600 text-lg mb-2">
                        Datos del destinatario
                    </div>
                    <div class="flex flex-col">
                        <div
                            class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                        >
                            <div class="w-full h-24">
                                <label for="nombre" class="my-1 text-gray-700">
                                    Nombre<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="nombre"
                                    :class="[
                                        't-input',
                                        errors?.nombre && 't-input-invalid',
                                    ]"
                                    v-model="form.nombre"
                                    placeholder="ej. Romina Campos"
                                />
                                <small
                                    v-if="errors?.nombre"
                                    id="nombre-help"
                                    class="p-error"
                                >
                                    {{ errors.nombre }}
                                </small>
                            </div>

                            <div class="w-full h-24">
                                <label
                                    for="documento"
                                    class="my-1 text-gray-700"
                                >
                                    Nro. documento<span class="text-red-400"
                                        >*</span
                                    >
                                </label>
                                <input
                                    type="text"
                                    id="documento"
                                    :class="[
                                        't-input',
                                        errors?.documento && 't-input-invalid',
                                    ]"
                                    v-model="form.documento"
                                    placeholder="ej. 99999999"
                                />
                                <small
                                    v-if="errors?.documento"
                                    id="documento-help"
                                    class="p-error"
                                >
                                    {{ errors.documento }}
                                </small>
                            </div>
                        </div>

                        <div
                            class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                        >
                            <div class="w-full h-24">
                                <label for="email" class="my-1 text-gray-700">
                                    Email<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    :class="[
                                        't-input',
                                        errors?.email && 't-input-invalid',
                                    ]"
                                    v-model="form.email"
                                    placeholder="ej. romina.campos75@gmail.com"
                                />
                                <small
                                    v-if="errors?.email"
                                    id="email-help"
                                    class="p-error"
                                >
                                    {{ errors.email }}
                                </small>
                            </div>

                            <div class="w-full h-24">
                                <label
                                    for="telefono"
                                    class="my-1 text-gray-700"
                                >
                                    Telefono<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="tel"
                                    id="telefono"
                                    :class="[
                                        't-input',
                                        errors?.telefono && 't-input-invalid',
                                    ]"
                                    v-model="form.telefono"
                                    placeholder="ej. +54 11 1234-5678"
                                />
                                <small
                                    v-if="errors?.telefono"
                                    id="telefono-help"
                                    class="p-error"
                                >
                                    {{ errors.telefono }}
                                </small>
                            </div>
                        </div>

                        <div class="w-full h-24">
                            <label for="calle" class="my-1 text-gray-700">
                                Calle<span class="text-red-400">*</span>
                            </label>
                            <input
                                type="text"
                                id="calle"
                                :class="[
                                    't-input',
                                    errors?.calle && 't-input-invalid',
                                ]"
                                v-model="form.calle"
                                placeholder="ej. Av. San Martín"
                            />
                            <small
                                v-if="errors?.calle"
                                id="calle-help"
                                class="p-error"
                            >
                                {{ errors.calle }}
                            </small>
                        </div>

                        <div
                            class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                        >
                            <div class="w-full h-24">
                                <label for="altura" class="my-1 text-gray-700">
                                    Altura<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="altura"
                                    :class="[
                                        't-input',
                                        errors?.altura && 't-input-invalid',
                                    ]"
                                    v-model="form.altura"
                                    placeholder="ej. 4864"
                                />
                                <small
                                    v-if="errors?.altura"
                                    id="altura-help"
                                    class="p-error"
                                >
                                    {{ errors.altura }}
                                </small>
                            </div>

                            <div class="w-full h-24">
                                <label for="piso" class="my-1 text-gray-700">
                                    Piso
                                </label>
                                <input
                                    type="text"
                                    id="piso"
                                    :class="[
                                        't-input',
                                        errors?.piso && 't-input-invalid',
                                    ]"
                                    v-model="form.piso"
                                    placeholder="ej. 4"
                                />
                                <small
                                    v-if="errors?.piso"
                                    id="piso-help"
                                    class="p-error"
                                >
                                    {{ errors.piso }}
                                </small>
                            </div>
                        </div>

                        <div
                            class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                        >
                            <div class="w-full h-24">
                                <label for="dpto" class="my-1 text-gray-700">
                                    Dpto.
                                </label>
                                <input
                                    type="text"
                                    id="dpto"
                                    :class="[
                                        't-input',
                                        errors?.dpto && 't-input-invalid',
                                    ]"
                                    v-model="form.dpto"
                                    placeholder="ej. Centro"
                                />
                                <small
                                    v-if="errors?.dpto"
                                    id="dpto-help"
                                    class="p-error"
                                >
                                    {{ errors.dpto }}
                                </small>
                            </div>

                            <div class="w-full h-24">
                                <label for="cp" class="my-1 text-gray-700">
                                    Código Postal<span class="text-red-400"
                                        >*</span
                                    >
                                </label>
                                <input
                                    type="text"
                                    id="cp"
                                    :class="[
                                        't-input',
                                        errors?.cp && 't-input-invalid',
                                    ]"
                                    v-model="form.cp"
                                    placeholder="ej. 6000"
                                />
                                <small
                                    v-if="errors?.cp"
                                    id="cp-help"
                                    class="p-error"
                                >
                                    {{ errors.cp }}
                                </small>
                            </div>
                        </div>

                        <div
                            class="flex flex-col space-y-2 lg:space-y-0 lg:flex-row lg:space-x-2"
                        >
                            <div class="w-full h-24">
                                <label
                                    for="localidad"
                                    class="my-1 text-gray-700"
                                >
                                    Localidad<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="localidad"
                                    :class="[
                                        't-input',
                                        errors?.localidad && 't-input-invalid',
                                    ]"
                                    v-model="form.localidad"
                                    placeholder="ej. Junín"
                                />
                                <small
                                    v-if="errors?.localidad"
                                    id="localidad-help"
                                    class="p-error"
                                >
                                    {{ errors.localidad }}
                                </small>
                            </div>

                            <div class="w-full h-24">
                                <label
                                    for="provincia"
                                    class="my-1 text-gray-700"
                                >
                                    Provincia<span class="text-red-400">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="provincia"
                                    :class="[
                                        't-input',
                                        errors?.provincia && 't-input-invalid',
                                    ]"
                                    v-model="form.provincia"
                                    placeholder="ej. Buenos Aires"
                                />
                                <small
                                    v-if="errors?.provincia"
                                    id="provincia-help"
                                    class="p-error"
                                >
                                    {{ errors.provincia }}
                                </small>
                            </div>
                        </div>

                        <div class="w-full h-24">
                            <label for="observacion" class="my-1 text-gray-700">
                                Observación
                            </label>
                            <input
                                type="text"
                                id="observacion"
                                placeholder="detalles adicionales"
                                :class="[
                                    't-input',
                                    errors?.observacion && 't-input-invalid',
                                ]"
                                v-model="form.observacion"
                            />
                            <small
                                v-if="errors?.observacion"
                                id="observacion-help"
                                class="p-error"
                            >
                                {{ errors.observacion }}
                            </small>
                        </div>

                        <div class="flex flex-col mb-4">
                            <div class="text-[12px] text-gray-600">
                                <span class="text-red-400">*</span>
                                <span>es requerido</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-4 flex justify-end lg:max-w-3xl">
                <Button @click.prevent="update">
                    Actualizar destinatario
                </Button>
            </div>
        </form>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import TextButton from "@/shared/TextButton.vue";

export default {
    components: {
        AppLayout,
        Link,
        Icon,
        AngleRight,
        Breadcrumb,
        Button,
        TextButton,
    },
    props: {
        destinatario: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                nombre: this.destinatario.nombre,
                documento: this.destinatario.documento,
                telefono: this.destinatario.documento,
                email: this.destinatario.documento,
                cp: this.destinatario.documento,
                calle: this.destinatario.documento,
                altura: this.destinatario.documento,
                piso: this.destinatario.documento,
                dpto: this.destinatario.documento,
                localidad: this.destinatario.documento,
                provincia: this.destinatario.documento,
                observacion: this.destinatario.documento,
            }),
            errors: null,
        };
    },
    methods: {
        update() {
            this.form.put(`/directorio/${this.destinatario.id}`, {
                onError: (errors) => {
                    this.errors = errors;
                },
            });
        },
    },
};
</script>

<style scoped>
.p-inputtext:enabled:focus,
.p-password-input:enabled:focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}
.p-inputtext:hover,
.p-password-input:hover {
    border-color: #829fc1;
}
</style>
